import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Grid, Slider, Box, TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            thousandSeparator={"'"}
            valueIsNumericString
            prefix="CHF "
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
        />
    );
});

function BAVSlider(props) {
    function initValue({ response, valueField, defaultValue }) {
        const key = valueField || "value_1";
        const raw = response?.[key];

        if (raw == null || raw === "" || isNaN(parseInt(raw, 10))) {
            return defaultValue ?? 0;
        }
        return parseInt(raw, 10);
    }

    const [value, setValue] = useState(() => initValue(props));
    const lastSentRef = useRef(null); // last persisted numeric value (dedupe)

    useEffect(() => {
        setValue(initValue(props));
    }, [props.response, props.valueField, props.defaultValue]);

    // keep lastSent in sync with DB-provided value (prevents false duplicate sends)
    useEffect(() => {
        const key = props.valueField || "value_1";
        const raw = props.response?.[key];
        if (raw != null && raw !== "" && !isNaN(parseInt(raw, 10))) {
            lastSentRef.current = parseInt(raw, 10);
        }
    }, [props.response, props.valueField]);

    const handleInputChange = (e) => {
        // NumericFormatCustom liefert value als string (digits only)
        const parsed = e.target?.value ? parseInt(e.target.value, 10) : 0;
        setValue(Number.isNaN(parsed) ? 0 : parsed);
    };

    const handleSliderChange = (_, newValue) => {
        setValue(newValue);
    };

    const persistIfChanged = (numeric) => {
        const v = Number(numeric) || 0;
        if (typeof props.callback === "function" && lastSentRef.current !== v) {
            // call parent save
            props.callback(props, v);
            lastSentRef.current = v;
        }
    };

    const handleChangeCommitted = (_, newValue) => {
        persistIfChanged(newValue);
    };

    const handleBlur = () => {
        persistIfChanged(value);
    };

    return (
        <Box sx={{ width: "100%" }} className="bavSlider">
            <Grid container spacing={20} alignItems="center">
                {props.title && (
                    <Grid item xs={2}>
                        {props.title}
                    </Grid>
                )}

                <Grid item xs={props.title ? 6 : 8}>
                    <Slider
                        value={typeof value === "number" ? value : 0}
                        min={props.min}
                        max={props.max}
                        step={props.step}
                        onChange={handleSliderChange}
                        onChangeCommitted={handleChangeCommitted}
                        disabled={props.readOnly}
                        id={props.id}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        value={value}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        size="large"
                        InputProps={{
                            inputComponent: NumericFormatCustom,
                        }}
                        disabled={props.readOnly}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default BAVSlider;   